import "./style.css";
import { o } from "./base-D76d76ww-Cfj0C7wU-t3aFpU0S-EPtA8WJt.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function d(i, c) {
  return (r, n, l) => {
    const s = (u) => {
      var e, t;
      return (t = (e = u.renderRoot) == null ? void 0 : e.querySelector(i)) != null ? t : null;
    };
    if (c) {
      const { get: u, set: e } = typeof n == "object" ? r : l != null ? l : (() => {
        const t = Symbol();
        return { get() {
          return this[t];
        }, set(h) {
          this[t] = h;
        } };
      })();
      return o(r, n, { get() {
        let t = u.call(this);
        return t === void 0 && (t = s(this), (t !== null || this.hasUpdated) && e.call(this, t)), t;
      } });
    }
    return o(r, n, { get() {
      return s(this);
    } });
  };
}
export {
  d as query
};
